export const genderOptions = [
  { value: '', label: '' },
  { value: 'm', label: 'Male' },
  { value: 'f', label: 'Female' },
  { value: 'nb', label: 'Non-binary' },
  { value: 'o', label: 'Other' },
  { value: 'x', label: 'Not specified' },
];
